import React from 'react';
import { arrayOf, element } from 'prop-types';

import { Grid, GridCol } from 'up-design-system-gex';

const TableActions = ({ left, right }) => (
    <Grid>
        {left && (
            <GridCol equalizeHeight size={{ m: 'fill' }}>
                {left.map(action => action)}
            </GridCol>
        )}
        {right && (
            <GridCol equalizeHeight size={{ m: 'fill' }}>
                {right.map(action => action)}
            </GridCol>
        )}
    </Grid>
);
TableActions.displayName = 'TableActions';
TableActions.propTypes = {
    left: arrayOf(element),
    right: arrayOf(element),
};

export default TableActions;